"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductPanel = _interopRequireDefault(require("./productPanel/ProductPanel"));
var _Disclosures = _interopRequireDefault(require("./disclosure/Disclosures"));
var _RequestedAmount = _interopRequireDefault(require("./requestedAmount/RequestedAmount"));
var _Error = _interopRequireDefault(require("./errorComponent/Error"));
require("./index.scss");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var INSTALLMENT_LOAN = 'INSTALLMENT_LOAN';
var AddlTrans = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AddlTrans, _React$Component);
  var _super = _createSuper(AddlTrans);
  function AddlTrans(props) {
    var _this;
    (0, _classCallCheck2.default)(this, AddlTrans);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ytsOriginalTransaction", function () {
      var spinner = document.getElementsByClassName('spinner');
      var _this$props = this.props,
        url = _this$props.url,
        applicationId = _this$props.applicationId,
        clientId = _this$props.clientId;
      var params = {
        applicationId: applicationId,
        clientId: clientId,
        minAmount: this.minAmount,
        maxAmount: this.maxAmount
      };
      var that = this;
      _lcHttp.default.get(url, {
        params: params
      }).then(function (res) {
        if (res.data.amountRemaining.returnCode.toLowerCase() !== 'approved') {
          that.setState({
            isError: res.data.amountRemaining.returnCode,
            applicantInfo: res.data.originalTransaction
          });
        } else {
          var person = res.data;
          person.limits.maximum = person.amountRemaining.otbAmount;
          that.setState({
            person: person
          });
        }
        [].forEach.call(spinner, function (element) {
          element.style.display = 'none';
        });
      }).catch(function (err) {
        console.log(err);
        [].forEach.call(spinner, function (element) {
          element.style.display = 'none';
        });
        that.props.onError('Error fetching available transactions.');
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lcpsOriginalTransaction", function () {
      var _this2 = this;
      var spinner = document.getElementsByClassName('small-loader');
      this.onSuccess = this.props.onSuccess;
      var _this$props2 = this.props,
        url = _this$props2.url,
        applicationId = _this$props2.applicationId;
      var urlOriginalTransaction = url + '?applicationId=' + applicationId;
      var that = this;
      _lcHttp.default.post(urlOriginalTransaction).then(function (res) {
        if (res.data.returnCode.toLowerCase() !== 'approved') {
          that.setState({
            isError: res.data.returnCode,
            applicantInfo: res.data.applicationUIModel
          });
        } else {
          var result = res.data;
          var person = _objectSpread({}, _this2.state.person);
          person.originalTransaction = result.applicationUIModel;
          person.limits.maximum = result.otbAmount;
          that.setState({
            person: person
          });
        }
        [].forEach.call(spinner, function (element) {
          element.style.display = 'none';
        });
        var lcpsDiv = document.getElementById('additional-transaction-react');
        lcpsDiv.style.display = 'block';
      }).catch(function (err) {
        console.log(err);
        [].forEach.call(spinner, function (element) {
          element.style.display = 'none';
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateOfferItems", function (text) {
      _this.setState({
        text: text
      }, function () {
        var url = _this.props.getProductsUrl;
        var params = null;
        if (_this.subMarket.toLowerCase() === 'lcps') {
          params = {
            loanAmount: _this.state.text
          };
        } else {
          params = {
            loanAmount: _this.state.text,
            applicationId: _this.props.applicationId,
            clientId: _this.props.clientId,
            minAmount: _this.minAmount,
            maxAmount: _this.maxAmount
          };
        }
        var that = (0, _assertThisInitialized2.default)(_this);
        _lcHttp.default.get(url, {
          params: params
        }).then(function (res) {
          if (_this.subMarket.toLowerCase() === 'lcps') {
            that.setState({
              products: res.data.content
            });
          } else {
            var _res$data = (0, _slicedToArray2.default)(res.data, 1),
              products = _res$data[0];
            that.setState({
              products: products
            });
          }
        }).catch(console.log);
      });
    });
    _this.state = {
      person: {
        limits: {
          maximum: null
        },
        amountRemaining: null,
        originalTransaction: null
      },
      applicantInfo: null,
      isError: null,
      products: [],
      selectedRadio: null
    };
    return _this;
  }
  (0, _createClass2.default)(AddlTrans, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subMarket = this.props.subMarket;
      if (this.subMarket.toLowerCase() === 'lcps') {
        this.lcpsOriginalTransaction();
      } else {
        this.ytsOriginalTransaction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var minAllowed, maxAllowed;
      if (this.state.products && this.state.products.length && this.state.text !== 'Initial Text') {
        var filtered = this.state.products.filter(function (_ref) {
          var productType = _ref.productType;
          return productType !== INSTALLMENT_LOAN;
        });
        minAllowed = Math.min.apply(Math, (0, _toConsumableArray2.default)(filtered.map(function (o) {
          return o.minimumAmount;
        })));
        maxAllowed = this.state.person.limits.maximum;
        this.state.text < minAllowed || this.state.text > maxAllowed ? this.inValidInput = true : this.inValidInput = false;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "main-div-additional-transaction"
      }, this.state.isError ? /*#__PURE__*/_react.default.createElement("div", {
        className: "main col-md-12"
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        applicantInfo: this.state.applicantInfo,
        isError: this.state.isError
      })) : this.state.person && this.state.person.originalTransaction ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "main col-md-12"
      }, /*#__PURE__*/_react.default.createElement(_RequestedAmount.default, {
        value: this.state.person,
        updateTextCB: this.updateOfferItems,
        inValidInput: this.inValidInput,
        minAllowed: minAllowed,
        maxAllowed: maxAllowed
      }), this.state.products && this.state.products.length ? /*#__PURE__*/_react.default.createElement(_ProductPanel.default, {
        products: this.state.products,
        selectedRadio: this.state.selectedRadio,
        onclick: this.onclick,
        applicationId: this.props.applicationId,
        clientId: this.props.clientId,
        onSuccess: this.props.onSuccess,
        onError: this.props.onError,
        inValidInput: this.inValidInput,
        maxAllowed: maxAllowed,
        additionalTransactionUrl: this.props.additionalTransactionUrl,
        subMarket: this.props.subMarket,
        constants: this.props.constants
      }) : null, /*#__PURE__*/_react.default.createElement(_Disclosures.default, this.props))) : null);
    }
  }]);
  return AddlTrans;
}(_react.default.Component);
(0, _defineProperty2.default)(AddlTrans, "defaultProps", {
  person: [],
  text: 'Initial Text',
  isError: null,
  updateOfferItems: null,
  lcpsOriginalTransaction: null,
  ytsOriginalTransaction: null,
  products: [],
  inValidInput: null,
  minAmount: 499,
  maxAmount: 50000,
  subMarket: null
});
AddlTrans.propTypes = {
  url: _propTypes.default.string,
  applicationId: _propTypes.default.string,
  clientId: _propTypes.default.string,
  getProductsUrl: _propTypes.default.string,
  onSuccess: _propTypes.default.func,
  onError: _propTypes.default.func,
  subMarket: _propTypes.default.string,
  additionalTransactionUrl: _propTypes.default.string,
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.object
};
var _default = AddlTrans;
exports.default = _default;
